import { dateAwareStructuralSharing } from "@klarify/ui/trpc/structural-sharing";
import {
	defaultShouldDehydrateQuery,
	QueryClient,
} from "@tanstack/react-query";
import { parse, stringify } from "superjson";

export function makeQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: {
				// With SSR, we usually want to set some default staleTime
				// above 0 to avoid refetching immediately on the client
				staleTime: 30 * 1000,
				// A tab refocus refires every mounted query at once. Surfaces that
				// need focus freshness opt in per query with refetchOnWindowFocus.
				refetchOnWindowFocus: false,
				// superjson revives Prisma timestamps as Date instances; treat
				// time-equal Dates as equal so unchanged payloads keep their
				// reference and refetches don't force broad re-renders.
				structuralSharing: dateAwareStructuralSharing,
			},
			dehydrate: {
				serializeData: stringify,
				shouldDehydrateQuery: (query) =>
					defaultShouldDehydrateQuery(query) ||
					query.state.status === "pending",
			},
			hydrate: {
				deserializeData: parse,
			},
		},
	});
}
